import React from 'react';
import PropTypes from 'prop-types';
import { usePopulate } from 'api/APIHooks';
import { Card, CardHeader } from 'common/Card';
import {
  AUTHORIZATION_STATUSES_TO_ICON,
  AUTHORIZATION_STATUSES_TO_COLOR,
} from 'common/Status/authorizationConstants';
import { FullWidthDetailList } from '../Layout';
import {
  BaseLineItem,
  NoteLineItem,
} from '../LineItems';

const ServiceAuthorizationRejectionCard = ({ authorization }) => {
  usePopulate(
    'service_authorization_denial_reason',
    'service_authorization_denial_reason',
    authorization,
    {
      queryConfig: {
        placeholderData: undefined,
      },
    },
  );

  const {
    service_authorization_denial_reason: { display_name: reason },
    adjudicator_note,
  } = authorization;

  return (
    <Card borderColor="border-red" className="p-2 bg-white">
      <CardHeader
        className="pt-4 space-y-4"
        title="Rejection Details"
        titleIcon={AUTHORIZATION_STATUSES_TO_ICON.denied}
        iconColor={AUTHORIZATION_STATUSES_TO_COLOR.denied}
      />
      <FullWidthDetailList className="px-4 py-6">
        <BaseLineItem field="Rejection Reason">
          {reason}
        </BaseLineItem>
        <NoteLineItem fieldName="Decision Note">
          {adjudicator_note || 'N/A'}
        </NoteLineItem>
      </FullWidthDetailList>
    </Card>
  );
};

ServiceAuthorizationRejectionCard.propTypes = {
  authorization: PropTypes.shape({
    service_authorization_denial_reason: PropTypes.shape({
      id: PropTypes.string.isRequired,
      display_name: PropTypes.string,
    }).isRequired,
    adjudicator_note: PropTypes.string,
  }).isRequired,
};

export default ServiceAuthorizationRejectionCard;
